import React from 'react';
import { FlameIcon } from 'lucide-react';
import { useRoleTheme } from '../../hooks/useRoleTheme';
const spiceLevels: Record<number, {
  label: string;
  color: string;
  darkColor: string;
}> = {
  1: {
    label: 'Mild',
    color: 'bg-sky-100 text-sky-700',
    darkColor: 'bg-sky-500/30 text-sky-200'
  },
  2: {
    label: 'Warm',
    color: 'bg-amber-100 text-amber-700',
    darkColor: 'bg-amber-500/30 text-amber-200'
  },
  3: {
    label: 'Spicy',
    color: 'bg-orange-100 text-orange-700',
    darkColor: 'bg-orange-500/30 text-orange-200'
  },
  4: {
    label: 'Extra Hot',
    color: 'bg-rose-100 text-rose-700',
    darkColor: 'bg-rose-500/30 text-rose-200'
  },
  5: {
    label: 'Inferno',
    color: 'bg-red-100 text-red-700',
    darkColor: 'bg-red-500/30 text-red-200'
  }
};
interface HeatLevelIndicatorProps {
  level: number;
  darkMode?: boolean;
}
const HeatLevelIndicator: React.FC<HeatLevelIndicatorProps> = ({
  level = 0,
  darkMode = false
}) => {
  const rt = useRoleTheme();
  if (level <= 0 || !spiceLevels[level]) return null;
  const {
    label,
    color,
    darkColor
  } = spiceLevels[level];
  return <span className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 ${rt.badgeRadius} font-medium ${darkMode ? darkColor : color}`} data-id="element-3804" data-mp="2f7dtczy1j44b">
      <FlameIcon className="h-3 w-3" data-id="element-3805" data-mp="2ozjk66ck3fhx" />
      {label}
    </span>;
};
export default HeatLevelIndicator;